import type { LucideIcon } from "lucide-react"
import { MessageCircle, PhoneIncoming, PhoneOutgoing } from "lucide-react"

// IMP-520: one definition of how a channel looks, shared by the conversation
// feed and the message inbox so a call reads the same wherever it appears.

export type Channel = "inbound" | "outbound" | "chat"

// Inbound/outbound are mirrored glyphs — the arrow runs into the handset on
// one and out of it on the other — so direction reads without the label.
export const channelIcons: Record<Channel, LucideIcon> = {
  inbound: PhoneIncoming,
  outbound: PhoneOutgoing,
  chat: MessageCircle,
}

export const channelLabels: Record<Channel, string> = {
  inbound: "Inbound call",
  outbound: "Outbound call",
  chat: "Website chat",
}
